export enum ComponentSource {
  HotelViewRoomsSection = 'hotelViewRoomsSection',
  RoomSelection = 'roomSelection',
  SearchViewTopOffers = 'searchViewTopOffers',
  HotelViewTopOffers = 'hotelViewTopOffers',
  SrpExitPopup = 'srpExitPopup'
}

export enum DealFreezeOnboardingSource {
  DealFreezeButton = 'dealFreezeButton',
  RoomBanner = 'roomBanner'
}
